import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { T } from "../i18n/strings";

const CONTENT = {
  about: {
    headline: T.labels.aboutHeadline,
    body: {
      en: [
        "POLITICAL WINDOW | Janela Política is an editorial publication devoted to global political affairs, with special attention to the evolving relationship between Brazil and the United States.",
        "Our editorial vantage point is the window — a deliberate framing device that lets readers see broad landscapes and small human moments at the same time. We publish original reporting, analysis, and long-form commentary in Portuguese and English.",
        "The site is bilingual by design. Every headline, deck, and article is available in both languages, and editors can switch between them at any time.",
        "This publication is illustrative — the content is user-published rather than fabricated news — and the platform is designed to support a professional editorial team.",
      ],
      pt: [
        "POLITICAL WINDOW | Janela Política é uma publicação editorial dedicada aos assuntos políticos globais, com atenção especial à relação em evolução entre o Brasil e os Estados Unidos.",
        "Nosso ponto de vista editorial é a janela — um enquadramento deliberado que permite aos leitores ver paisagens amplas e pequenos momentos humanos ao mesmo tempo. Publicamos reportagens originais, análise e comentário em profundidade em português e inglês.",
        "O site é bilíngue por design. Toda manchete, subtítulo e artigo está disponível em ambos os idiomas, e os editores podem alternar entre eles a qualquer momento.",
        "Esta publicação é ilustrativa — o conteúdo é publicado pelo usuário e não uma notícia fabricada — e a plataforma foi projetada para apoiar uma equipe editorial profissional.",
      ],
    },
  },
  privacy: {
    headline: T.labels.privacyHeadline,
    body: {
      en: [
        "We collect only the information necessary to operate this publication — namely, the contact information you voluntarily submit through forms.",
        "We do not sell or share personal information with third parties. Analytics, if enabled, are aggregated and anonymous.",
        "Editorial cookies store your language preference locally in your browser. You may clear them at any time from your browser settings.",
        "For questions about your data or to request deletion, please contact the editorial desk.",
      ],
      pt: [
        "Coletamos apenas as informações necessárias para operar esta publicação — a saber, as informações de contato que você envia voluntariamente por meio de formulários.",
        "Não vendemos nem compartilhamos informações pessoais com terceiros. Análises, se habilitadas, são agregadas e anônimas.",
        "Cookies editoriais armazenam sua preferência de idioma localmente no seu navegador. Você pode apagá-los a qualquer momento nas configurações do navegador.",
        "Para dúvidas sobre seus dados ou para solicitar exclusão, entre em contato com a redação.",
      ],
    },
  },
  terms: {
    headline: T.labels.termsHeadline,
    body: {
      en: [
        "By accessing POLITICAL WINDOW, you agree to use the content for personal, non-commercial reading and reference.",
        "Editorial content is protected by copyright. Excerpts may be quoted with appropriate attribution and a link back to the original article.",
        "The publication may update these terms from time to time; substantive changes will be announced on this page.",
        "For licensing inquiries, please contact the editorial desk.",
      ],
      pt: [
        "Ao acessar POLITICAL WINDOW, você concorda em usar o conteúdo para leitura e referência pessoal e não comercial.",
        "O conteúdo editorial é protegido por direitos autorais. Trechos podem ser citados com atribuição apropriada e um link de volta para o artigo original.",
        "A publicação pode atualizar estes termos periodicamente; mudanças substantivas serão anunciadas nesta página.",
        "Para consultas de licenciamento, entre em contato com a redação.",
      ],
    },
  },
};

export default function StaticPage({ page }) {
  const { lang } = useLanguage();
  const c = CONTENT[page];
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 lg:py-16" data-testid={`static-${page}`}>
      <div className="pw-eyebrow">{T.labels.editorial[lang]}</div>
      <h1 className="font-serif-display text-4xl lg:text-5xl font-bold text-[#081422] mt-2 mb-8">
        {c.headline[lang]}
      </h1>
      <div className="pw-article-body">
        {c.body[lang].map((p, i) => <p key={i}>{p}</p>)}
      </div>
    </div>
  );
}
